module.exports = __webpack_public_path__ + "static/assets/6326ff41cb30d9fd198ce6d1c80d81d2.png";